import * as SystemCountConstants from "../constants/SystemCount";
import * as FeelingFactorsConstants from "../modules/feeling_factors/constants";
import * as StudyConstants from "../modules/studies/constants/Studies";

const initialState = {
  counts: {},
  isFetching: false
};

//FIXME(Keune): Calculate new Count, when object created/deleted
//FIXME(Keune): Calculate, when Drug created/deleted
//FIXME(Keune): Calculate, when Study created/deleted

export function systemCounts(state = initialState, action) {
  switch (action.type) {
    case SystemCountConstants.SYSTEM_COUNT_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case SystemCountConstants.SYSTEM_COUNT_FETCH_COMPLETED:
      return Object.assign({}, state, {
        counts: action.counts,
        isFetching: false
      });
    case FeelingFactorsConstants.FEELING_FACTOR_SUBMIT_COMPLETED: {
      const newFeelingFactorsCounts = Object.assign({}, state.counts, {feeling_factors_count: state.counts.feeling_factors_count + 1});

      return action.isNew? Object.assign({}, state, {counts: newFeelingFactorsCounts}) : state;
    }

    case FeelingFactorsConstants.FEELING_FACTOR_DELETE_COMPLETED: {
      const newFeelingFactorsCounts = Object.assign({}, state.counts, {feeling_factors_count: state.counts.feeling_factors_count - 1});

      return Object.assign({}, state, {counts: newFeelingFactorsCounts});
    }

    case StudyConstants.SYSTEM_STUDY_DELETE_COMPLETED: {
      const newStudyCounts = Object.assign({}, state.counts, {study_count: state.counts.study_count - 1});

      return Object.assign({}, state, {counts: newStudyCounts});
    }
    default:
      return state;
  }
}
